// Reusable JSON-LD Schema generators for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "LegalService",
  "name": "Daniel Albert Law Firm",
  "description": "Comprehensive legal representation in Immigration, Criminal Defense, Personal Injury, Family Law, Tax, Probate, Real Estate, and Business Law",
  "url": "https://danielalbertlaw.com",
  "telephone": "+18329303059",
  "email": "info@danielalbertlaw.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "10925 Beechnut St A106",
    "addressLocality": "Houston",
    "addressRegion": "TX",
    "postalCode": "77072",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "29.6567",
    "longitude": "-95.5867"
  },
  "openingHours": "Mo-Fr 09:00-18:00, Sa 10:00-14:00",
  "priceRange": "$$",
  "areaServed": [
    {
      "@type": "City",
      "name": "Houston"
    },
    {
      "@type": "State",
      "name": "Texas"
    }
  ],
  "knowsLanguage": ["en", "es", "vi"],
  "logo": "https://danielalbertlaw.com/logo.png",
  "image": "https://danielalbertlaw.com/og-image.jpg",
  "sameAs": [
    "https://www.facebook.com/danielalbertlaw",
    "https://www.linkedin.com/company/danielalbertlaw"
  ]
};

export const attorneySchema = {
  "@context": "https://schema.org",
  "@type": "Attorney",
  "name": "Daniel Albert",
  "jobTitle": "Attorney at Law",
  "worksFor": {
    "@type": "LegalService",
    "name": "Daniel Albert Law Firm"
  },
  "knowsLanguage": ["en", "es", "vi"],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "10925 Beechnut St A106",
    "addressLocality": "Houston",
    "addressRegion": "TX",
    "postalCode": "77072",
    "addressCountry": "US"
  },
  "telephone": "+18329303059",
  "email": "info@danielalbertlaw.com"
};

export const generateServiceSchema = (serviceName: string, description: string, url: string) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "description": description,
  "provider": {
    "@type": "LegalService",
    "name": "Daniel Albert Law Firm",
    "url": "https://danielalbertlaw.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Houston"
  },
  "url": url
});

export const generateLocalBusinessSchema = (area: string, city: string, description: string) => ({
  "@context": "https://schema.org",
  "@type": "LegalService",
  "name": `Daniel Albert Law Firm - Immigration Services in ${area}`,
  "description": description,
  "url": `https://danielalbertlaw.com/areas/${area.toLowerCase().replace(/\s+/g, '-')}`,
  "telephone": "+18329303059",
  "email": "info@danielalbertlaw.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": city,
    "addressRegion": "TX",
    "addressCountry": "US"
  },
  "areaServed": {
    "@type": "City",
    "name": area
  },
  "serviceType": "Immigration Law",
  "knowsLanguage": ["en", "es", "vi"]
});

export const generateArticleSchema = (title: string, description: string, publishDate: string, modifiedDate: string, url: string) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": title,
  "description": description,
  "author": {
    "@type": "Organization",
    "name": "Daniel Albert Law Firm"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Daniel Albert Law Firm",
    "logo": {
      "@type": "ImageObject",
      "url": "https://danielalbertlaw.com/logo.png"
    }
  },
  "datePublished": publishDate,
  "dateModified": modifiedDate,
  "url": url
});